import { render } from "./DeleteAutCredentials.vue?vue&type=template&id=54aaf528&scoped=true"
import script from "./DeleteAutCredentials.vue?vue&type=script&lang=js"
export * from "./DeleteAutCredentials.vue?vue&type=script&lang=js"

import "./DeleteAutCredentials.vue?vue&type=style&index=0&id=54aaf528&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54aaf528"]])

export default __exports__